<div [ngClass]="{ 'with-margin': enableMargin }" class="touch-indicator-container">
  <ng-content></ng-content>
  <i *ngIf="!disabled" class="zmdi zmdi-chevron-right"></i>
</div>
